<template>
  <section class="main-content">
    <MainBanner v-if="service.title" :banner="leistungensingle" :key="service.id" />
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Leistungen",
        "item": "https://ito-consult.de/leistungen"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "{{service.title}}",
        "item": "https://ito-consult.de/leistungen/{{service.slug}}"
      }]
    }
  </script>
    <section class="block-content mb-5">
      <div class="container my-5 py-5">
        <div class="content-midwide text-center" data-aos="fade-up" data-aos-duration="500">
            <h2>{{service.title}}</h2>
        </div>
      </div>
    </section>
    <section class="block-content mb-5">
      <div class="container my-5 py-5">
        <div id="services">
          <div v-for="(content,index) in service.content_element" :key="index"  class="row my-5 py-5 align-items-center" data-aos="fade-up" data-aos-duration="500">
            <div v-if="content.image" class="col-12 col-md-5 mb-3 mb-md-0" :class="{'order-md-2  offset-md-1' : index%2==0 }">
              <div class="img-container">
                <img class="img-fluid" v-if="content.image.data" width="640" height="360"  :src="generateThumbnail(content.image.data.asset_url,640,360,50,'contain')" :title="content.title" :alt="content.title" />
              </div>
            </div>
            <div class="col-12" :class="{'offset-md-1':(index%2 && content.image), 'col-md-6': content.image}">
              <h2>{{content.title}}</h2>
              <article class="d-content" v-html="content.description"></article>
              <a class="btn btn-outline-ito hover-red animated-arrow mt-3 d-inline-flex align-items-center" v-if="content.link_text && content.link_url" :target="content.target ? '_blank' : 'self'" :href="content.link_url">
                <svg data-v-4c99373d="" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path data-v-4c99373d="" fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"></path></svg>
                {{ content.link_text }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="brands" class="block-content mb-5">
      <div class="container my-5 py-5">
        <div id="tools">
           <h2>{{brands.title}}</h2>
          <div class="row my-5 align-items-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
            <div class="col-6 col-md mb-3" v-for="(b, idx) in brands.brand" :key="idx">
              <a class="brand_logo text-center" :href="b.url" target="_blank" :title="b.title">
                <img width="250" height="250" class="img-fluid" v-if="b.logo.data" :src="generateThumbnail(b.logo.data.asset_url,250,250,60,'contain')" :title="b.title" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'
import router from '@/router'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'ServiceSingle',
  metaInfo () {
    return {
      title: this.getMetaTitle(),
      meta: [
        { name: 'description', content: this.getDescription() },
        { property: 'og:title', content: this.getOGTitle() },
        { property: 'og:description', content: this.getOGDescription() }
      ]
    }
  },
  data: function () {
    return {
      service: {},
      brands: {},
      temp_img: null
    }
  },
  computed: {
    service_id: function () {
      return this.$route.params.id
    },
    leistungensingle: function () {
      return 'Leistungen.' + this.service.title
    }
  },
  methods: {
    async getServiceContent () {
      await axios.get('/services?filter[slug]=' + this.service_id)
        .then(response => {
          if (response.data.data.length > 0) {
            this.service = response.data.data[0]
            store.commit('loadingStatus', false)
          } else {
            // Falls slug in directus nicht vorhanden, 404 Umleitung
            router.replace({ name: '404' })
          }
          //  holen der Bild URL
          for (var i = 0; i < this.service.content_element.length; i++) {
            const ele = this.service.content_element[i]
            if (ele.image) {
              axios.get('https://cdn.ito-consult.de/itoconsult/files/' + ele.image)
                .then(response => (ele.image = response.data.data))
            }
          }
          axios.get('/brands?filter[route]=' + this.leistungensingle)
            .then(response => {
              this.brands = response.data.data[0]
              //  holen der Bild URL
              for (var i = 0; i < this.brands.brand.length; i++) {
                const ele = this.brands.brand[i]
                if (ele.logo) {
                  axios.get('https://cdn.ito-consult.de/itoconsult/files/' + ele.logo)
                    .then(response => (ele.logo = response.data.data))
                }
              }
            })
        })
    },
    generateThumbnail (asset, w, h, q, f) {
      return 'https://cdn.ito-consult.de' + asset + '?w=' + w + '&h=' + h + '&q=' + q + '&f=' + f
    },
    getMetaTitle () {
      if (typeof this.$store.getters.meta.data !== 'undefined') {
        const txt = this.$store.getters.meta.data.filter(item => {
          return item.route.indexOf(this.leistungensingle) > -1
        })
        return txt.length ? txt[0].meta_title : ''
      } else {
        return ''
      }
    },
    getOGTitle () {
      if (typeof this.$store.getters.meta.data !== 'undefined') {
        const txt = this.$store.getters.meta.data.filter(item => {
          return item.route.indexOf(this.leistungensingle) > -1
        })
        return txt.length ? txt[0].og_title : ''
      } else {
        return ''
      }
    },
    getDescription () {
      if (typeof this.$store.getters.meta.data !== 'undefined') {
        const txt = this.$store.getters.meta.data.filter(item => {
          return item.route.indexOf(this.leistungensingle) > -1
        })
        return txt.length ? txt[0].meta_description : ''
      } else {
        return ''
      }
    },
    getOGDescription () {
      if (typeof this.$store.getters.meta.data !== 'undefined') {
        const txt = this.$store.getters.meta.data.filter(item => {
          return item.route.indexOf(this.leistungensingle) > -1
        })
        return txt.length ? txt[0].og_description : ''
      } else {
        return ''
      }
    }
  },
  async beforeMount () {
    this.service = this.getServiceContent()
  },
  components: {
    MainBanner
  },
  watch: {
    // whenever question changes, this function will run
    service_id: function (val, old) {
      if (val !== old) {
        this.getServiceContent()
      }
    }
  }
}
</script>

<style scoped>
  .brand_logo {background: #eee; display: block; overflow: hidden;}
  .brand_logo img {transition: all 500ms; filter: grayscale(1);}
  .brand_logo:hover img {filter: grayscale(0); transform: scale(1.05,1.05);}

  #services .img-container {display: block; overflow: hidden;}
  #services .img-container img {filter: grayscale(1); transition: all 1s;}
  #services .row:hover .img-container img {filter: grayscale(0); transform: scale(1.05,1.05);}
  #services .d-content >>> ul {
    list-style: none; margin: 0; padding: 0;
  }
  #services .d-content >>> ul li {
    padding-left: 2rem;
    position: relative;
  }
  #services .d-content >>> ul li:after {
    content:'';
    display: block;
    color: #666;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 0; top: .25rem;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16"><path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/></svg>');
    background-repeat: no-repeat;
  }
</style>
